export function EventContentSwapNew() {
  return <span className="flex gap-1 flex-wrap">Started the swap</span>;
}
